import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2025 Schwimm und Tauchgemeinschaft DiverDuck e.V.</p>
      <p>
        <a href="/impressum">Impressum</a> | <a href="/datenschutz">Datenschutz</a> | <a href="/kontakt">Kontakt</a>
      </p>
      <p>Adresse: Seestr. 98, 15738 Zeuthen - E-Mail: diver.duck@web.de</p>
    </footer>
  );
}
